import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import CreditNoteForm from '../../creditNotes/components/CreditNoteForm';
import DetailsPageActionButtons from '../components/DraftDetailsPageActions';
import { useGetCreditNoteHandler } from '../../creditNotes/dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function DraftsCreditNoteDetailsPage() {
  useDocumentTitle('Credit Note Details');
  const { document_id } = useParams();
  const navigate = useNavigate();

  const { creditNote, isLoading } = useGetCreditNoteHandler(document_id);
  if (isLoading || !creditNote) {
    return <DocumentSkeletonForm />;
  }

  const handleBack = () => {
    navigate('/drafts?tab=credit-notes');
  };

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box sx={{ pb: 4 }}>
        <TopBar title="Credit Note Details" subTitle={creditNote?.document_id}>
          <DetailsPageActionButtons onBack={handleBack} />
        </TopBar>
      </Box>
      <CreditNoteForm onSubmit={() => {}} onCancel={() => {}} initialData={creditNote} readOnly={true} />
    </Stack>
  );
}
